<template>
	<fragment>
		<GeminiScrollbar class="my-scroll-bar alloc-my-scrollbar">
			<div
				class="table-container"
				:style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth}px`}"
			>
				<scroll-sync horizontal>
					<div class="master-head" ref="masterHeadScroll">
						<!--Loop through the allocation data to set the month-year header-->
						<template v-for="(allocation,index) in allocations">
							<div class="master-head-month" :key="index">
								<div class="master-h">
									<h3 class="month-name">{{allocation.monthNameAndYear}}</h3>
								</div>
							</div>
						</template>
					</div>
					<div class="table-wrapper">
						<div class="master-table-head-box">
							<div
								class="each-month each-month-header"
								:key="index"
								v-for="(allocation,index) in allocations"
							>
								<div class="master-table-head mh-days">
									<div>
										<div class="master-table-text right-table-header">Days</div>
									</div>
								</div>
								<div class="master-table-head mh-vac">
									<div>
										<div class="master-table-text right-table-header vac">Vac.</div>
									</div>
								</div>
               
								<div class="master-table-head mh-sick">
									<div>
										<div class="master-table-text right-table-header sick">Sick</div>
									</div>
								</div>
								<div class="master-table-head mh-other">
									<div>
										<div class="master-table-text right-table-header other">Other</div>
									</div>
								</div>
                <div class="master-table-head mh-not-yet-approved-holiday">
									<div>
										<div class="master-table-text right-table-header not-yet-approved-holiday">Vac.Plan</div>
									</div>
								</div>
								<div class="master-table-head mh-act">
									<div>
										<div class="master-table-text right-table-header act">Act.</div>
									</div>
								</div>
								<div class="master-table-head mh-note">
									<div>
										<div class="master-table-text right-table-header note-t">Note</div>
									</div>
								</div>
								<div class="master-table-head mh-tv">
									<div>
										<div class="master-table-text right-table-header tv">Turnover</div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="master-table report-master-table-set inner-master-table"
							:style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth }px`}"
							v-bar
						>
							<scroll-sync group="one" vertical>
								<div class="master-table" ref="masterTableRight" :class="loaderClass">
									<div
										class="each-month"
										v-for="(allocation,allocationIndex) in allocations"
										:key="allocationIndex"
										ref="allocationRow"
									>
										<table class="month-table forecast-allocation-month-table">
											<template v-for="(monthlyAllocation,index) in allocation.forecastMonthlyAllocations">
												<allocation-month
													:monthlyAllocation="monthlyAllocation"
													:index="index"
													:allocationIndex="allocationIndex"
													:key="allocationIndex+'_'+index"
												></allocation-month>
											</template>
										</table>
									</div>
								</div>
							</scroll-sync>
						</div>
					</div>
				</scroll-sync>
				<scroll-sync horizontal>
					<allocation-result></allocation-result>
				</scroll-sync>
			</div>
		</GeminiScrollbar>
	</fragment>
</template>

<script>
const AllocationMonth = () => import("./allocations/AllocationMonth");
const AllocationResult = () => import("./allocations/Result");
const { observer } = require("vue-mutation-observer");

export default {
  name: "Allocations",
  components: { AllocationMonth, AllocationResult },
  data() {
    return {
      masterTableWidth: 0,
      masterTableFinalWidth: 0,
      monthTableWidth: 0,
      isDomReady: false,
      allocationLength: 0,
      loaderClass: ""
    };
  },
  directives: { observer },
  computed: {
    /**
     * Allocation data from store
     */
    allocations: function() {
      return this.$store.state.forecast.allocations;
    }
  },
  updated() {
    this.setTableWidth();
    this.updateLoader();
  },
  created() {
    // Hiding the loader once the component is created
    this.isDomReady = true;
    this.updateLoader();
  },
  mounted() {
    this.setTableWidth();
    this.setTablePadding();
    setTimeout(() => {
      this.HeadHorizontalScroll();
    }, 500);
  },
  methods: {
    /**
     * Set the width after the data load
     */
    setTableWidth: function() {
      //Adding actual width
      setTimeout(() => {
        let element = document.querySelector(".right-table .gm-scroll-view");
        // static width of each-month class (added in css) * length of total allocation
        if (element != undefined && element != null) {
          //old
          // this.masterTableWidth = (element.scrollWidth);
          if (this.allocations.length > 0) {
            this.masterTableWidth =
              398 * this.$store.state.forecast.allocations.length + 10;
          } else {
            this.masterTableWidth = document.querySelector(
              ".right-table"
            ).offsetWidth;
          }
        }
      }, 500);
    },
    setTablePadding: function() {
      setTimeout(() => {
        this.masterTableWidth += 100;
      }, 800);
    },
    /**
     * Set the loader class on all component loaded
     */
    updateLoader: function() {
      setTimeout(() => {
        if (
          typeof this.$refs.allocationRow !== "undefined" &&
          this.$refs.allocationRow.length === this.allocations.length
        ) {
          this.loaderClass = "master-table-loaded";
        }
      }, 200);
    },

    /*
     * For horizontal scroll
     * when scrolling using mouse wheels over Month header on the top section (allocation side),
     */
    HeadHorizontalScroll: function() {
      let ScrollElement = this.$refs.masterHeadScroll,
        scrollableElement = document.querySelector(
          ".alloc-my-scrollbar .gm-scroll-view"
        ),
        i = 0;

      ScrollElement.addEventListener("wheel", function(e) {
        //When dragging to left side
        if (e.deltaY < 0 && !e.shiftKey) {
          if (i >= 0) {
            //if Scroll left == 0
            scrollableElement.scrollLeft = i;
            i = i - 50;
          } else {
            i = 0;
          }
        }

        //Mouse wheel and horizontal scroll for allocation's headers
        else if (e.deltaY > 0 && !e.shiftKey) {
          if (i <= scrollableElement.scrollWidth) {
            //if Scroll left !== end of the div
            scrollableElement.scrollLeft = i;
            i = i + 50;
          } else {
            i = scrollableElement.scrollWidth;
          }
        }
      });
    }
  },
  watch: {
    /**
     * Watch if the allocation data is fetch
     */
    allocations: function() {
      // call the function after the allocation data is loaded
      this.setTableWidth();
    }
  }
};
</script>

<style scoped>
	.my-scroll-bar {
		height: 100vh;
		overflow-y: hidden;
	}

	.my-scroll-bar.gm-scrollbar-container .gm-scroll-view {
		overflow-y: hidden !important;
	}

	/* Master page on allocation */
	/* .master-table {
		max-height: calc(100vh - 300px);
		min-height: calc(100vh - 300px);
		height: calc(100vh - 300px);
		/* padding-bottom: 16px; */
		/* padding-bottom: 0; */
	/* } */ 
  
  	.master-table {
		max-height: calc(100vh - 300px);
		min-height: calc(100vh - 300px);
		height: calc(100vh - 300px);
		/* padding-bottom: 16px; */
		padding-bottom: 0;
	}
  
  
  
  
  @media screen and (max-width: 1440px){
    .master-table {
      max-height: calc(100vh - 320px);
      min-height: calc(100vh - 320px);
      height: calc(100vh - 320px);
      /* padding-bottom: 16px; */
      padding-bottom: 0;
	  }
  }
</style>
